import apiClient from '@/lib/api-client';

export interface BankAccount {
    id: string;
    bankName: string;
    accountNumber: string;
    accountName: string;
    accountType: string;
    currency: string;
    currentBalance: string;
    openingBalance: string;
    isActive: boolean;
    isDefault: boolean;
    branchId: string | null;
    businessId: string | null;
    branchName?: string;
    businessName?: string;
    createdAt: string;
    updatedAt: string;
}

export interface AccountTransaction {
    id: string;
    bankAccountId: string;
    type: 'credit' | 'debit';
    amount: string;
    balanceBefore: string;
    balanceAfter: string;
    source: string;
    description: string | null;
    createdAt: string;
}

export async function getBankAccounts(params: { branchId?: string; businessId?: string } = {}): Promise<BankAccount[]> {
    const response = await apiClient.get('/bank-accounts', { params });
    return response.data?.data || [];
}

export async function getBankAccountById(id: string): Promise<BankAccount> {
    const response = await apiClient.get(`/bank-accounts/${id}`);
    return response.data?.data;
}

export async function createBankAccount(payload: {
    bankName: string; accountNumber: string; accountName: string;
    accountType?: string; currency?: string; openingBalance?: number;
    branchId?: string; businessId?: string; isDefault?: boolean;
}): Promise<BankAccount> {
    const cleanPayload = Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v !== undefined && v !== '' && v !== null)
    );
    const response = await apiClient.post('/bank-accounts', cleanPayload);
    return response.data?.data;
}

export async function updateBankAccount(id: string, payload: Record<string, unknown>): Promise<BankAccount> {
    const cleanPayload = Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v !== undefined && v !== '')
    );
    const response = await apiClient.patch(`/bank-accounts/${id}`, cleanPayload);
    return response.data?.data;
}

export async function deleteBankAccount(id: string): Promise<void> {
    await apiClient.delete(`/bank-accounts/${id}`);
}

export async function getAccountTransactions(
    accountId: string,
    params: { limit?: number; page?: number; source?: string } = {}
): Promise<{ transactions: AccountTransaction[]; totalCount: number }> {
    const response = await apiClient.get(`/bank-accounts/${accountId}/transactions`, { params });
    return {
        transactions: response.data?.data?.transactions || [],
        totalCount: response.data?.data?.totalCount || 0,
    };
}